export interface DisneyRetirementPolicy {
  retired: boolean;
  cutover_at: string;
  server_time_ms: number;
}

// Online only. License availability remains controlled by its existing policy.
export const getDisneyRetirementDeadline = (policy: unknown, requestStartedAt: number): number => {
  if (!policy || typeof policy !== 'object') throw new Error('Missing retirement policy');
  const value = policy as Partial<DisneyRetirementPolicy>;
  if (typeof value.retired !== 'boolean' || !Number.isFinite(value.server_time_ms)) {
    throw new Error('Invalid retirement policy');
  }
  if (value.retired) return requestStartedAt;
  if (typeof value.cutover_at !== 'string' || !/(Z|[+-]\d{2}:\d{2})$/.test(value.cutover_at)) {
    throw new Error('Missing retirement timezone');
  }
  const cutover = Date.parse(value.cutover_at);
  if (!Number.isFinite(cutover)) throw new Error('Invalid retirement date');
  // performance.now() is independent of a wrong or subsequently changed device clock.
  // Count the complete round trip conservatively so network latency cannot extend access.
  return requestStartedAt + Math.max(0, cutover - value.server_time_ms!);
};

export const isC3RetiredError = (status: number | undefined, data: unknown): boolean => {
  if (status !== 410 || !data || typeof data !== 'object') return false;
  const details = (data as { details?: unknown }).details;
  return !!details && typeof details === 'object' && (details as { code?: unknown }).code === 'C3_RETIRED';
};
